import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PreviewFileModalComponent } from '@modals/preview-file/preview-file.component';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { FileUtils } from '@utils/FileUtils';

@Component({
    selector: 'avatar-image',
    templateUrl: './avatar-image.component.html',
    styleUrls: ['./avatar-image.component.scss'],
})
export class AvatarImageComponent implements OnInit, OnChanges {

    @Input('data') Data: { Url: string, Name: string };
    @Input('disabled') Disabled: boolean = true;

    @Input('canViewEdit') CanViewEdit: boolean = false;

    @Input() presentModal: Function = new Function();
    @Output() callback = new EventEmitter<{ Url: string, Name: string }>();

    public DefaultImage: string;

    constructor(
        private ModalController: ModalController
    ) { }



    ngOnInit(): void {
    }

    ngOnChanges(e): void {
        console.log(e, this.Data);

        // this.DefaultImage = 'assets/project/default_image.jpg';
    }

    public OnPresentImage(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (!this.Disabled && this.CanViewEdit) {
            this.onPresentModal();
        }
        else
            this.onViewImage(ev);
    }

    private async onPresentModal() {

        const { role, data } = await this.presentModal(this.Data);

        if (role == EnumGenericRoleActionAlerts.Save) {

            const base64 = await FileUtils.GetBase64FromUrl(data?.objectUrl);
            this.Data = { Url: base64, Name: data?.name };

            if (this.callback) this.callback.emit(this.Data);

        }

    }

    /**
     * 
     * @param ev 
     * @returns 
     */
    private async onViewImage(ev: any) {


        const modal = await this.ModalController.create({
            component: PreviewFileModalComponent,
            componentProps: {
                url: this.Data?.Url
            },
            cssClass: 'default'
        });

        await modal.present();

        return await modal.onDidDismiss();
    }

}
